import { timeline } from "@/mocks/gossip";

const todayTop = timeline.slice(0, 3);

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* top marquee */}
      <div className="border-y border-background-200 bg-background-100/80">
        <div className="flex items-center gap-3 overflow-hidden px-4 py-2">
          <span className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-semibold text-foreground-950">
            <i className="ri-flashlight-fill"></i> 滚动快讯
          </span>
          <div className="relative min-w-0 flex-1 overflow-hidden">
            <div className="flex w-max animate-[marquee_32s_linear_infinite] gap-10 whitespace-nowrap">
              {[...timeline.slice(0, 4), ...timeline.slice(0, 4)].map((t, i) => (
                <span key={`${t.id}-${i}`} className="text-sm text-foreground-700">
                  {t.date} · {t.title}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>

      <div className="container-x grid gap-10 pb-14 pt-12 md:pb-20 md:pt-16 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            九月娱乐圈大瓜 · 全程回顾
          </span>

          <h1 className="mt-5 font-heading text-4xl font-black leading-[1.15] text-foreground-950 md:text-5xl">
            本月大瓜时间线，
            <br />
            一条脉络<span className="text-primary-500">看懂全程</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-7 text-foreground-700 md:text-lg md:leading-8">
            从爆发的第一手信息，到发酵、回应再到收尾，我们把本月大瓜按发生顺序逐条还原成清晰经过。
            脉络不绕弯、先后不颠倒，吃瓜全程一次看明白。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-50 transition-transform hover:-translate-y-0.5 hover:bg-primary-600"
            >
              <i className="ri-time-line"></i> 查看本月时间线
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              先看焦点速览
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>

          <dl className="mt-9 grid max-w-md grid-cols-3 divide-x divide-background-200">
            <div className="pr-4">
              <dt className="text-xs text-foreground-500">本月收录</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">9 条</dd>
            </div>
            <div className="px-4">
              <dt className="text-xs text-foreground-500">热点事件</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-500">5 件</dd>
            </div>
            <div className="pl-4">
              <dt className="text-xs text-foreground-500">全程还原</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">100%</dd>
            </div>
          </dl>
        </div>

        {/* right editorial card stack */}
        <div className="relative">
          <div className="absolute -right-6 -top-6 hidden h-28 w-28 rounded-full border-8 border-dashed border-primary-200 lg:block"></div>
          <div className="relative overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-3">
              <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-radio-2-line text-primary-500"></i> 今日瓜况速报
              </span>
              <span className="text-xs text-foreground-500">实时热度</span>
            </div>
            <div className="flex flex-col divide-y divide-background-200">
              {todayTop.map((t, idx) => (
                <a href="#timeline" key={t.id} className="group flex gap-3 px-5 py-4 transition-colors hover:bg-background-50">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-foreground-950">
                    {idx + 1}
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                      {t.title}
                    </p>
                    <div className="mt-1.5 flex flex-wrap items-center gap-2">
                      <span className="text-xs text-foreground-500">{t.date}</span>
                      <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">
                        <i className="ri-fire-fill"></i> {t.heat}°
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
            <a
              href="#timeline"
              className="flex items-center justify-between border-t border-background-200 bg-background-50/60 px-5 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              展开完整时间线
              <i className="ri-arrow-right-s-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}